import { render, staticRenderFns } from "./WikiButton.vue?vue&type=template&id=5c400832&"
import script from "./WikiButton.vue?vue&type=script&lang=js&"
export * from "./WikiButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c400832')) {
      api.createRecord('5c400832', component.options)
    } else {
      api.reload('5c400832', component.options)
    }
    module.hot.accept("./WikiButton.vue?vue&type=template&id=5c400832&", function () {
      api.rerender('5c400832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WikiButton.vue"
export default component.exports